export const getCurrentStep = state => state.recordTableUI.currentStep;
export const getSelectedFileId = state => state.recordTableUI.selectedFileId;
export const getImportStatus = state => state.recordTableUI.importStatus;
